import { render, staticRenderFns } from "./EditServiceSideBar.vue?vue&type=template&id=d004565e&"
import script from "./EditServiceSideBar.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBar.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports